import styled from 'styled-components';
import { Button } from '../RequestAuthorization/styles';

export const WrapperPage = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  .banner-container {
    display: flex;
    justify-content: center;
    border-radius: 10px;
    img {
      border-radius: 10px;
      width: 100%;
    }
  }
  .buttons-container {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    gap: 30px;
    button {
      max-width: 300px;
      width: 100%;
    }
    @media (min-width: 1024px) {
      flex-direction: row;
      justify-content: center;
    }
  }
`;

export const ContainerPage = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
`;

export const TitlePage = styled.h1`
  font-family: 'Unimed-Slab-Bold';
  font-size: 2.55rem;
  line-height: 2.4rem;
  text-align: center;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.palet.institutional6};
  padding: 30px 0;
  @media (max-width: 1200px) {
    font-size: 2.25rem;
    line-height: 2.1rem;
  }
  @media (max-width: 768px) {
    font-size: 1.7rem;
    line-height: 1.5rem;
  }
`;

export const TermContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 310px;
  overflow-y: auto;
  @media (min-width: 768px) {
    max-height: 400px;
  }
  @media (min-width: 1440px) {
    max-height: 600px;
  }
`;

export const TextInfoTerm = styled.p`
  display: block;
  gap: 30px;
  font-size: 16px;
  font-family: 'Unimed-Sans-Book';
  color: ${(props) => props.theme.colors.text.blackToWhite};
  text-align: center;
  margin-bottom: 20px;

  @media (min-width: 1024px) {
    text-wrap: nowrap;
  }
`;

export const InfoTerm = styled.span`
  color: blue;
  cursor: pointer;
  transition: 300ms;
  margin-left: 5px;
  &:hover {
    text-decoration: underline;
  }
`;

export const ButtonStyled = styled(Button)`
  margin-left: 0px;
  border: 1px solid #5b5c65;
`;

export const ContainerBeneficiaryList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;

  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
  }
`;

export const ContainerUpdateData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;
  @media (min-width: 1024px) {
    width: 600px;
  }
`;

export const ContentUpdateData = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  max-height: 300px;
  padding: 0.5rem;
  overflow-y: auto;
  gap: 10px;
`;

export const WrapperUpdateData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const DataTitle = styled.span`
  font-size: 0.8rem;
  color: #5b5c65;
  font-family: 'Unimed-Sans-Book';
  text-align: left;
`;

export const DataValue = styled.span`
  font-size: 0.8rem;
  font-weight: 600;
  color: #333;
  font-family: 'Unimed-Sans-Book';
  text-align: left;
`;
